/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */

// eslint-disable-next-line jira/restricted/@atlassian/react-resource-router
import { createResource, type Match, type RouteResource } from '@atlassian/react-resource-router';
import { fetchPlanSidebarNavInfo } from '../../../services/sidebar/plan-sidebar-navigation/fetchPlanSidebarNavInfo.tsx';
import type { PlanSidebarNavInfo } from '../../../services/sidebar/plan-sidebar-navigation/types.tsx';

const getRouterKey = (match: Match): string => {
	if (match.url.includes('/plans/')) {
		return `planId-${match.params.planId || ''}-scenarioId-${match.params.scenarioId || ''}`;
	}

	return 'none';
};

export const staticPlanSidebarNavigationResource: RouteResource<PlanSidebarNavInfo | null> =
	createResource<PlanSidebarNavInfo | null>({
		type: 'NAVIGATION_SIDEBAR_JIRA_PLAN',
		// oxlint-disable-next-line no-explicit-any
		getKey: ({ match }: { match: any }) => getRouterKey(match),
		getData: async ({
			match: {
				params: { planId, scenarioId },
			},
		}) => {
			if (planId == null || scenarioId == null) {
				return null;
			}

			return fetchPlanSidebarNavInfo(planId, scenarioId);
		},
		maxAge: 5 * 60 * 1000,
		isCritical: true,
	});
